import { Mail, Phone, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { COMPANY } from "../mock";

export default function TopBar() {
  return (
    <div className="hidden md:block bg-[#0a2540] text-white text-sm">
      <div className="container-x flex items-center justify-between py-2">
        <div className="flex items-center gap-6">
          <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-amber-300 transition-colors">
            <Mail size={14} /> {COMPANY.email}
          </a>
          {COMPANY.phones.map((p) => (
            <a key={p.number} href={`tel:${p.number.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-amber-300 transition-colors">
              <Phone size={14} /> {p.label} - {p.number}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          {[Facebook, Twitter, Linkedin, Instagram].map((Icon, i) => (
            <a key={i} href="#" className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/25 flex items-center justify-center transition-colors">
              <Icon size={13} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
